<template>
  <div>
    <span :class="`${customClassLabel}`" style="min-height: 24px;">
      {{ showLabel ? getLabel : "" }}
      <WarningCitizenIdIcon v-if="showWarning && locale == 'th'" v-model="taxId" :class='customClassWarning' :isVat="getIsVat"
        :isExport="getIsExport" @onWriteData="onWriteData" />
    </span>
    <v-tooltip top :disabled="!isDisabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-text-field :class="customClassInput" :solo="solo" :flat="flat" :placeholder="showPlaceholder ? getLabel : ''"
            :background-color="backgroundColor" :outlined="outlined" :dense="dense" :hide-details='hideDetails'
            :label="getLabel" v-model="taxId" :counter="locale == 'th' ? counter : false"
            :rules="getRules && locale == 'th' ? [getRules.texId, getRules.numbersOnly] : []" :disabled="isDisabled || froceDisabled"></v-text-field>
        </div>
      </template>
      <div>{{ $t('validate.you_do_not_have_permission_to_edit_tax_id') }}</div>
    </v-tooltip>
  </div>
</template>

<script>
import WarningCitizenIdIcon from "@/components/WarningCitizenIdIcon";
import { mapGetters } from "vuex"
export default {
  components: {
    WarningCitizenIdIcon,
  },
  props: {
    value: [String, Number],
    showLabel: Boolean,
    showPlaceholder: Boolean,
    getLabel: {
      type: String,
      default() {
        return this.$t('tax.tax_id_number_another_form');
      },
    },
    getIsVat: Boolean,
    getIsExport: Boolean,
    getRules: Object,
    isCreate: {
      default: false,
      type: Boolean
    },
    counter: {
      type: [Boolean, Number],
      default: 13,
    },
    solo: {
      type: Boolean,
      default: true,
    },
    flat: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      default: "grey lighten-4",
      type: String
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    showWarning: {
      type: Boolean,
      default: false,
    },
    customClassLabel: {
      type: String,
      default: ""
    },
    froceDisabled: {
      type: Boolean,
      default: false
    },
    customClassWarning: String,
    customClassInput: String,
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
    };
  },
  computed: {
    ...mapGetters({
      adminGetByMarketId: "admin/getByMarketId",
      employeeGetByMarketId: "employee/getByMarketId",
      adminGetByProjectId: "admin/getByProjectId",
      employeeGetByProjectId: "employee/getByProjectId",
      getUserInfo: "user/getUserInfo"
    }),
    taxId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    employee() {
      return this.employeeGetByMarketId(this.marketId);
    },
    admin() {
      return this.adminGetByMarketId(this.marketId);
    },
    admins() {
      return this.adminGetByProjectId(this.projectId);
    },
    employees() {
      return this.employeeGetByProjectId(this.projectId);
    },
    project() {
      if (this.admins && this.admins.length) {
        return this.admins[0].project;
      } else if (this.employees && this.employees.length) {
        return this.employees[0].project;
      } else if (this.admin) {
        return this.admin.project;
      } else if (this.employee) {
        return this.employee.project;
      }
      return { locale: "th" };
    },
    locale() {
      return this.project?.locale || "th";
    },
    enableEditTaxId() {
      return this.employees?.find(d => d.enableEditTaxId)
    },

    isDisabled: {
      get() {
        let res = true
        if ((this.employee?.enableEditTaxId) || (this.admins && this.admins.length) || this.isCreate) {
          res = false;
        }
        else {
          res = true;
        }
        return res
      },
      set(val) {

      }

    }
  },
  methods: {
    onWriteData(val) {
      this.$emit("onWriteData", val)
    },
  },
};
</script>